<cu-review-card-renderer-resolver [page]="page"  [card]="card" [cardIndex]="cardIndex" ></cu-review-card-renderer-resolver>
